import PropTypes from 'prop-types';
import { commonPropTypes, } from '../../interfaces/commonProps';
import { spacingPropTypes } from '../../interfaces/layoutProps';
export const formGroupPropTypes = {
    disabled: PropTypes.bool,
    hint: PropTypes.string,
    invalid: PropTypes.bool,
    label: PropTypes.string,
    required: PropTypes.bool,
    validationMessage: PropTypes.string,
    ...commonPropTypes,
    ...spacingPropTypes,
};
//# sourceMappingURL=FormGroup.types.js.map